/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_System_Prompt_RequiredInputs */



/**
* | output |
* | --- |
* | "Please enter the instructions." |
*
* @param {Agent_Builder_System_Prompt_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_system_prompt_required = /** @type {((inputs?: Agent_Builder_System_Prompt_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_System_Prompt_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie die Anweisungen ein.")
	return /** @type {LocalizedString} */ ("Please enter the instructions.")
});